export class GA4Settings extends HTMLElement {
  constructor() {
    super();
  }

  static row_types = ["All Phone Calls", "Sales Calls", "Service Calls", "Parts Calls", "Sales Appointment Calls", "Service Appointment Calls", "Chats", "SMS", "Web Forms"];

  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;
    let res = await fetch(`/admin/domains/${this.domain_id}/ga4`);
    let json = await res.json();

    this.innerHTML =
      `
      <style>
        .ga4_row, .ga4_enabled_flex_column, .ga4_enabled_head {
          display: flex;
        }

        .ga4_enabled_flex_column, #measurement_id, #auth_token_secret {
          margin-bottom: 20px;
        }

        .ga4_enabled_flex_column, .ga4_enabled_head {
          align-items: center;
        }

        .ga4_enabled_div, .ga4_enabled_head {
          justify-content: center;
        }
      </style>
      <div class="ga4-main row">
        <div class="col-md-12">
          <h3>GA4 Integration</h3>
        </div>
        <div class="col-md-6">
          <div class="errors"></div>
          <label>Measurement ID</label>
          <input type="text" class="form-control" id="measurement_id" name="measurement_id" autocomplete="measurement_id" placeholder="" value="${json.google_analytics4_measurement_id ? json.google_analytics4_measurement_id : ''}" maxlength="64">
          <label>GA4 API Secret</label>
          <input type="text" class="form-control" id="auth_token_secret" placeholder="" value="${json.google_analytics4_auth_token_secret ? json.google_analytics4_auth_token_secret : ''}" maxlength="255">
          <h3>Events</h3>
          <div class="col-md-3 no-gutters"><label>Category Type</label></div>
          <div class="col-md-2 no-gutters ga4_enabled_head"><label>Enabled</label></div>
          <div class="col-md-7 no-gutters"><label>Category Name</label></div>
          <div class="ga4_rows"></div>
          <button class="btn btn-primary pull-right save_ga4">Save</button>
        </div>
        <div class="col-md-5 col-md-offset-1">
          <h5><b>Google Analytics 4</b></h5>
          <p>
            GA4, or Google Analytics 4, is the latest version of Google's web analytics platform. It offers enhanced features, including cross-device tracking, advanced machine learning capabilities, and event-based data collection, to provide deeper insights into user behavior and help businesses make data-driven decisions.
          </p>
          <p>
            <b>Measurement ID:</b> Measurement ID is a unique identifier associated with a specific property within your GA4 account. <a href="https://support.google.com/analytics/answer/12270356?hl=en" target="_blank">[GA4] Tracking ID support</a>
          </p>
          <p>
            <b>GA4 API Secret:</b> GA4 API Secret allows us to authenticate with Google to send your events. <a href="https://support.google.com/analytics/answer/9814495" target="_blank">[GA4] Generate API secrets for Measurement Protocol</a>
          </p>
          <p>
            <b>Events:</b> Enable the events you want to be sent to GA4. Each event type that is enabled requires a name. This is what you will see on Google Anayltics.
          </p>
        </div>
      </div>
      `;

    GA4Settings.row_types.forEach(row_type => {
      this.querySelector('.ga4_rows').append(new GA4Row(row_type, json.google_analytics4s));
    })

    this.querySelector('.save_ga4').addEventListener('click', function(e) {
      e.preventDefault()
      this.save();
    }.bind(this))
  }

  validate() {
    let is_valid = true;
    this.querySelector('.errors').innerHTML = '';
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })
    if(!this.querySelector('#measurement_id').value.trim()) {
      this.querySelector('#measurement_id').classList.add('error');
      this.querySelector('.errors').innerHTML += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please enter a Measurement ID.
                                                  </div>`;

      is_valid = false;
    }
    if(!this.querySelector('#auth_token_secret').value.trim()) {
      this.querySelector('#auth_token_secret').classList.add('error');
      this.querySelector('.errors').innerHTML += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please enter an Authorization Token Secret.
                                                  </div>`;

      is_valid = false;
    }

    let rows_valid = true;
    this.querySelectorAll('ga4-row').forEach(elem => {
      if(!elem.validate()) {
        rows_valid = false;
        is_valid = false;
      }
    })
    if(!rows_valid) {
      this.querySelector('.errors').innerHTML += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please enter a Category Name.
                                                  </div>`;
    }

    return is_valid
  }

  async save() {
    if(!this.validate()) {
      return
    }

    let data = {
      google_analytics4_measurement_id: this.querySelector('#measurement_id').value.trim(),
      google_analytics4_auth_token_secret: this.querySelector('#auth_token_secret').value.trim(),
      google_analytics4s: []
    }

    this.querySelectorAll('ga4-row').forEach(elem => {
      data.google_analytics4s.push(elem.getData());
    })

    console.log(data)
    this.querySelector('.save_ga4').disabled = true;
    let res = await fetch(`/admin/domains/${this.domain_id}/ga4`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(data)
    })

    let response = await res.json();
    if(response.success) {
      Common.notify('GA4 settings updated', 'success');
    } else {
      Common.notify(`Unable to update GA4 settings. ${response.error ? response.error : ""}`, 'error');
    }

    this.querySelector('.save_ga4').disabled = false;
  }
}

customElements.define('ga4-settings', GA4Settings)

class GA4Row extends HTMLElement {
  constructor(row_type, all_row_data) {
    super();
    this.row_type = row_type;
    this.all_row_data = all_row_data;
    this.type_formatted = row_type.replace(/\s/g, "_").toLowerCase();
  }

  static TYPE_TABLE_NAMES = {
    all_phone_calls: "ALL_CALLS",
    sales_calls: "SALES_CALLS",
    service_calls: "SERVICE_CALLS",
    parts_calls: "PARTS_CALLS",
    sales_appointment_calls: "SALES_APPT",
    service_appointment_calls: "SERVICE_APPT",
    chats: "CHATS",
    sms: "SMS",
    web_forms: "WEB_FORMS"
  }
  connectedCallback() {
    let row_data = this.all_row_data.length ? this.all_row_data.filter(obj => {
      return obj.event_type == GA4Row.TYPE_TABLE_NAMES[this.type_formatted]
    })[0] : null;

    this.innerHTML =
      `
      <style>
        
      </style>
      <div class="ga4_row col-md-12 no-gutters">
        <div class="col-md-3 no-gutters ga4_enabled_flex_column">
          <h5>${this.row_type}</h5>
        </div>
        <div class="col-md-2 no-gutters ga4_enabled_flex_column ga4_enabled_div">
          <input type="checkbox" class="" id="${this.type_formatted}_enabled" ${row_data && row_data.status == 1 ? 'checked' : ''}>
        </div>
        <div class="col-md-7 no-gutters">
          <input type="text" class="form-control" id="${this.type_formatted}_category_name" placeholder="" value="${row_data && row_data.event_name != null ? row_data.event_name : ''}" maxlength="50">
        </div>
      </div>
      `;
  }

  validate() {
    let is_valid = true;

    if(this.querySelector(`#${this.type_formatted}_enabled`).checked && !this.querySelector(`#${this.type_formatted}_category_name`).value.trim()) {
      this.querySelector(`#${this.type_formatted}_category_name`).classList.add('error');
      is_valid = false;
    }

    return is_valid
  }

  getData() {
    let data = {
      event_type: GA4Row.TYPE_TABLE_NAMES[this.type_formatted],
      event_name: this.querySelector(`#${this.type_formatted}_category_name`).value.trim() ? this.querySelector(`#${this.type_formatted}_category_name`).value.trim() : null,
      status: this.querySelector(`#${this.type_formatted}_enabled`).checked ? 1 : 0
    }

    return data
  }
}

customElements.define("ga4-row", GA4Row)